import { render, staticRenderFns } from "./SearchStudent.vue?vue&type=template&id=ca7ef5c4"
import script from "./SearchStudent.vue?vue&type=script&lang=js"
export * from "./SearchStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports